import React from "react";

function SpeedQualityScale() {
  const features = [
    {
      title: "Speed",
      description: "Production ready pilot in under 12 weeks. Accelerators, templates, and agents let us move faster."
    },
    {
      title: "Quality",
      description: "Transparent sprint governance. Named owners. Clear logs. Measured outcomes."
    },
    {
      title: "Scale",
      description: "We replicate proven solutions across functions, markets, and tech stacks - with governance intact."
    }
  ];

  return (
    <div className="py-12 md:py-18">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-10 md:mb-12">
            <h2 className="RoobertLight text-3xl md:text-4xl lg:text-5xl font-bold text-dark-blue mb-4">
              Speed, quality, and scale
            </h2>
            <h3 className="RoobertMedium text-xl md:text-2xl font-bold text-dark-blue mb-8">
              Repeatability beats reinvention. Every time.
            </h3>
          </div>

          {/* Three Feature Boxes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-10">
            {features.map((feature, index) => (
              <div key={index} className="relative bg-white p-6 md:p-8">
                {/* Dark blue L-shaped border */}
                <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-16 h-16"></div>
                
                <h4 className="RoobertMedium text-lg md:text-xl font-bold text-dark-blue mb-4">
                  {feature.title}
                </h4>
                <p className="RoobertRegular text-sm md:text-base text-dark-blue leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* Conclusion */}
          <div>
            <p className="RoobertRegular text-lg text-dark-blue leading-relaxed">
              This delivery structure allows clients to scale AI adoption without linearly increasing vendor headcount or internal fatigue.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpeedQualityScale;
